import { Grid, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';
import { useEffect, useRef, useState } from 'react'
import styles from './../../../../../assets/styles/componentStyles/widgetComponentStyles/tableFormat.module.scss'
import { primaryColor } from '../../../../../utils/colors';

const TableFormatView = (props: any) => {
    const { fields, handleMessageFormat, chatbotTheme, childData } = props;
    const [cellWidths, setCellWidths] = useState([]);
    const [cellHeights, setCellHeights] = useState([]);
    const cellRefs = useRef([]);

    useEffect(() => {

        if (fields && fields.table_rows.length > 0) {
            const widths: any = [];
            const heights: any = [];
            cellRefs?.current?.forEach((row) => {
                //@ts-ignore
                row?.forEach((cell: any) => {
                    widths.push(cell ? cell.offsetWidth : 0);
                    heights.push(cell ? cell.offsetHeight : 0)
                });
            });
            setCellWidths(widths);
            setCellHeights(heights);
        }

    }, [fields])

    const handleSumOfWidth = (index: any, cellLength: any, flagRight = false) => {
        if (flagRight) {
            let sum = 0;
            if (index > 0) {
                for (let i = index + 1; i < cellLength; i++) {
                    sum += cellWidths[i] - 0.5
                }
            }
            return sum;
        }
        else {
            let sum = 0;
            if (index == 0) {
                return sum;
            }
            else {
                for (let i = 0; i < index; i++) {
                    sum += cellWidths[i] - 0.25
                }
            }
            return sum + 0.25;
        }

    }

    const handleSumOfHeight = (index: any, flagBottom = false) => {
        let sum = 0;
        if (index > 0) {
            for (let i = 0; i < index; i++) {
                sum += cellHeights[i]
            }
        }
        return index > 0 ? flagBottom ? sum + 0.5 : sum + 0.25 : sum;
    }

    return (
        <>
            {childData ?
                <>
                    <Grid item className={styles.table_sub_fields_grid_style}>
                        <Grid container direction={"column"} gap={1}>
                            <Grid item className={styles.table_name_heading_style}>
                                <span
                                    style={{
                                        color: chatbotTheme?.chatbot_send_message_icon_color ? `${chatbotTheme?.chatbot_send_message_icon_color} !important` : primaryColor,
                                    }}
                                >
                                    {childData.title}
                                </span>
                            </Grid>

                            <Grid item>
                                <TableContainer sx={{ borderRadius: "5px", border: "1px solid #E9E9E9", maxWidth: "100%", overflow: "auto", marginTop: "5px", maxHeight: "350px !important" }}>
                                    <Table aria-label="simple table" stickyHeader>
                                        <TableBody>
                                            {Object.entries(childData.info).map(([key, value], rowIndex) =>
                                                <TableRow
                                                    sx={{
                                                        backgroundColor: fields?.style ?
                                                            rowIndex % 2 == 0 ? `${fields?.style?.rowColor1} !important` : `${fields?.style?.rowColor2} !important`
                                                            :
                                                            "",
                                                    }}
                                                    className={styles.table_format_row_style}>
                                                    <TableCell sx={{ whiteSpace: "nowrap", padding: "12px !important" }}>
                                                        <span className={styles.table_format_number_text_style}
                                                            style={{
                                                                color: chatbotTheme?.chatbot_send_message_icon_color ? `${chatbotTheme?.chatbot_send_message_icon_color} !important` : primaryColor,
                                                            }}
                                                        >
                                                            {key}
                                                        </span>
                                                    </TableCell>

                                                    <TableCell sx={{ padding: "12px !important" }}>
                                                        <span className={styles.table_format_name_text_style}>
                                                            {value as any}
                                                        </span>
                                                    </TableCell>
                                                </TableRow>
                                            )}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </Grid>
                        </Grid>
                    </Grid>

                </>
                :
                <TableContainer sx={{ maxWidth: "100%", maxHeight: "400px !important" }} className={styles.table_format_container_style}>
                    <Table aria-label="simple table" stickyHeader>
                        {fields.table_rows.slice(0, fields.freeze_top_row).map((headRow: any, rowIndex: number) =>
                            <TableHead>
                                {headRow.cell_data.map((cell: any, index: number) => {
                                    if (!cellRefs.current[rowIndex]) {
                                        //@ts-ignore
                                        cellRefs.current[rowIndex] = [];
                                    }

                                    const cellRef = (el: any) => {
                                        //@ts-ignore
                                        cellRefs.current[rowIndex][index] = el;
                                    };

                                    return (
                                        <TableCell
                                            key={index}
                                            ref={cellRef}
                                            className={index < fields.freeze_left_col ? `${styles.table_format_heading_cell_style} ${styles.table_format_column_sticky_style} ${styles.table_format_heading_style}` : styles.table_format_heading_cell_style}
                                            sx={{
                                                backgroundColor: fields?.style?.headerBgColor ?
                                                    fields?.style?.headerBgColor
                                                    :
                                                    cell.flag_header_cell ?
                                                        chatbotTheme?.chatbot_header_color ?
                                                            chatbotTheme?.chatbot_header_color :
                                                            chatbotTheme?.system_msg_bg_color ?
                                                                chatbotTheme?.system_msg_bg_color :
                                                                "#FFF" :
                                                        "#FFF",
                                                color: fields?.style?.headerTextColor ?
                                                    fields?.style?.headerTextColor
                                                    :
                                                    cell.flag_header_cell ?
                                                        chatbotTheme?.chatbot_header_font_color ?
                                                            `${chatbotTheme?.chatbot_header_font_color} !important`
                                                            :
                                                            chatbotTheme?.system_msg_bg_color ?
                                                                `${chatbotTheme?.system_msg_bg_color} !important`
                                                                :
                                                                "#000"
                                                        : "#000",
                                                top: rowIndex < fields.freeze_top_row ? `${handleSumOfHeight(rowIndex)}px !important ` : "",
                                                left: index < fields.freeze_left_col ? `${handleSumOfWidth(index, headRow.cell_data.length)}px !important` : "",
                                                right: index >= (headRow.cell_data.length - fields.freeze_right_col) ? `${handleSumOfWidth(index, headRow.cell_data.length, true)}px !important` : "",
                                                padding: cell.message_format_id === 3 ? "8px 14px !important" : "",
                                                textAlign: (cell.message_format_id === 3 || cell.message_format_id === 4) ? "center" : "",
                                                borderLeft: index >= (headRow.cell_data.length - fields.freeze_right_col) ? "1px solid #E9E9E9" : "none",
                                                borderRight: index < fields.freeze_left_col || index == headRow.cell_data.length - 1 ? "1px solid #E9E9E9" : (index >= (headRow.cell_data.length - fields.freeze_right_col) || index == (headRow.cell_data.length - fields.freeze_right_col - 1)) ? "none" : "1px solid #E9E9E9"
                                            }}
                                        >
                                            {handleMessageFormat(cell)}
                                        </TableCell>
                                    )
                                }

                                )}
                            </TableHead>
                        )}
                        {fields.table_rows.slice(fields.freeze_top_row, (fields.table_rows.length - fields.freeze_bottom_row)).map((headRow: any, rowIndex: number) =>
                            <TableBody>
                                {headRow.cell_data.map((cell: any, index: number) => {
                                    if (!cellRefs.current[rowIndex]) {
                                        //@ts-ignore
                                        cellRefs.current[rowIndex] = [];
                                    }

                                    const cellRef = (el: any) => {
                                        //@ts-ignore
                                        cellRefs.current[rowIndex][index] = el;
                                    };

                                    return (
                                        <TableCell
                                            key={index}
                                            ref={cellRef}
                                            className={index < fields.freeze_left_col ? `${styles.table_format_cell_style} ${styles.table_format_column_sticky_style}` : styles.table_format_cell_style}
                                            sx={{
                                                backgroundColor: fields?.style ?
                                                    rowIndex % 2 == 0 ? fields?.style?.rowColor1 : fields?.style?.rowColor2
                                                    :
                                                    cell.flag_header_cell ?
                                                        chatbotTheme?.chatbot_header_color ?
                                                            `${chatbotTheme?.chatbot_header_color} !important`
                                                            : "#FFF"
                                                        : chatbotTheme?.system_msg_bg_color ?
                                                            `${chatbotTheme?.system_msg_bg_color} !important`
                                                            : "#FFF",
                                                color: cell.flag_header_cell ?
                                                    chatbotTheme?.chatbot_header_font_color ?
                                                        `${chatbotTheme?.chatbot_header_font_color} !important`
                                                        :
                                                        "#000"
                                                    : chatbotTheme?.system_msg_color ?
                                                        `${chatbotTheme?.system_msg_color} !important`
                                                        :
                                                        "#000",
                                                position: index >= (headRow.cell_data.length - fields.freeze_right_col) ? "sticky !important" : "",
                                                left: index < fields.freeze_left_col ? `${handleSumOfWidth(index, headRow.cell_data.length)}px !important` : "",
                                                right: index >= (headRow.cell_data.length - fields.freeze_right_col) ? `${handleSumOfWidth(index, headRow.cell_data.length, true)}px !important` : "",
                                                padding: cell.message_format_id === 3 ? "8px 14px !important" : "",
                                                textAlign: (cell.message_format_id === 3 || cell.message_format_id === 4) ? "center" : "",
                                                borderLeft: index >= (headRow.cell_data.length - fields.freeze_right_col) ? "1px solid #E9E9E9 !important" : "none",
                                                borderRight: index < fields.freeze_left_col || index == headRow.cell_data.length - 1 ? "1px solid #E9E9E9 !important" : (index >= (headRow.cell_data.length - fields.freeze_right_col) || index == (headRow.cell_data.length - fields.freeze_right_col - 1)) ? "none" : "1px solid #E9E9E9"
                                            }}
                                        >
                                            {handleMessageFormat(cell)}
                                        </TableCell>
                                    )
                                })}
                            </TableBody>
                        )}
                        {fields.table_rows.slice((fields.table_rows.length - fields.freeze_bottom_row)).map((headRow: any, rowIndex: number) =>
                            <TableBody>
                                {headRow.cell_data.map((cell: any, index: number) => {
                                    if (!cellRefs.current[rowIndex]) {
                                        //@ts-ignore
                                        cellRefs.current[rowIndex] = [];
                                    }

                                    const cellRef = (el: any) => {
                                        //@ts-ignore
                                        cellRefs.current[rowIndex][index] = el;
                                    };

                                    return (
                                        <TableCell
                                            key={index}
                                            ref={cellRef}
                                            className={index < fields.freeze_left_col ? `${styles.table_format_cell_style} ${styles.table_format_column_sticky_style} ${styles.table_format_heading_style}` : styles.table_format_cell_style}
                                            sx={{
                                                backgroundColor: cell.flag_header_cell ?
                                                    chatbotTheme?.chatbot_header_color ?
                                                        `${chatbotTheme?.chatbot_header_color} !important`
                                                        : "#FFF"
                                                    : chatbotTheme?.system_msg_bg_color ?
                                                        `${chatbotTheme?.system_msg_bg_color} !important`
                                                        : "#FFF",
                                                color: cell.flag_header_cell ?
                                                    chatbotTheme?.chatbot_header_font_color ?
                                                        `${chatbotTheme?.chatbot_header_font_color} !important`
                                                        :
                                                        "#000"
                                                    : chatbotTheme?.system_msg_color ?
                                                        `${chatbotTheme?.system_msg_color} !important`
                                                        :
                                                        "#000",
                                                position: "sticky !important",
                                                left: index < fields.freeze_left_col ? `${handleSumOfWidth(index, headRow.cell_data.length)}px !important` : "",
                                                bottom: rowIndex < fields.freeze_bottom_row ? `${handleSumOfHeight(fields.table_rows.slice((fields.table_rows.length - fields.freeze_bottom_row + 1)).length - rowIndex, true)}px !important` : "",
                                                right: index >= (headRow.cell_data.length - fields.freeze_right_col) ? `${handleSumOfWidth(index, headRow.cell_data.length, true)}px !important` : "",
                                                padding: cell.message_format_id === 3 ? "8px 14px !important" : "",
                                                textAlign: (cell.message_format_id === 3 || cell.message_format_id === 4) ? "center" : "",
                                                borderLeft: index >= (headRow.cell_data.length - fields.freeze_right_col) ? "1px solid #E9E9E9 !important" : "none",
                                                borderRight: index < fields.freeze_left_col || index == headRow.cell_data.length - 1 ? "1px solid #E9E9E9 !important" : (index >= (headRow.cell_data.length - fields.freeze_right_col) || index == (headRow.cell_data.length - fields.freeze_right_col - 1)) ? "none" : "1px solid #E9E9E9"
                                            }}
                                        >
                                            {handleMessageFormat(cell)}
                                        </TableCell>
                                    )
                                })}
                            </TableBody>
                        )}
                    </Table>
                </TableContainer>}
        </>
    )
}

export default TableFormatView
